var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"threeText"},[_c('span',{staticClass:"text",style:({'color':_vm.control.color,'font-size':_vm.control.fontSize+'px','font-weight':_vm.control.bold})},[_vm._v(_vm._s(_vm.control.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }